// The ONE poster lookup every poster-ink component shares.
//
// A home-board POSTER card is theme-INVARIANT by construction: `_widget()`
// commits the card to one hue + its binary ink and repeats that background in
// BOTH scheme blocks (see pages/main.js `_widget`). Any descendant that paints
// an ADAPTIVE NEUTRAL token on it (`title` → rgb(4,4,4) light / rgb(241,241,243)
// dark, `caption` → rgb(36,36,40) / rgb(206,206,210)) is therefore wrong in one
// of the two themes by construction — measured 1.11–4.18:1 across the sub-cards
// on /w/system/hq (HOME-POSTER-NEUTRAL-INK-ON-HUE-1, 2026-08-22). The fix is
// never a per-component hue literal and never a new alpha: the descendant takes
// the POSTER's OWN ink, which resolves at paint time off the same
// `--color-poster<Family>Ink` var a branded workspace can override.
//
// `_widget()` stamps `posterId: spec.id` on the poster card; `el.lookup` walks
// ancestors with a ONE-argument predicate (never the `(el, s)` factory shape).
// Returns `null` outside a poster (a neutral card such as the greeting, a module
// widget, or the same shared component mounted on a plain page), so each caller
// keeps its own documented adaptive fallback.
//
// Deliberately NOT registered in functions/index.js: it takes the ELEMENT
// itself, and `el.call('name', …)` forwards arguments only — there is no call
// shape that could pass one. The two ink components import it directly.
//
// ⚠️ 2026-09-02 — the resolution moved from the HOUSE catalog to the USER's
// own colour (Nika: "make solid - a default color for all of them … add in
// context menu 'Add color'"). Every card still stamps `posterId`, including
// the neutral ones, because the stamp is now the widget IDENTITY the colour
// map is keyed by, not a claim that the card carries a hue. `null` — the
// neutral answer — is therefore the COMMON case, not the exception: a card
// with no user colour paints the adaptive glass, and a descendant that
// painted a poster ink on it would be white-on-white in one theme. That is
// exactly the bug class HOME-POSTER-NEUTRAL-INK-ON-HUE-1 fixed in the other
// direction, so both inks keep their neutral `title` / `caption` fallbacks
// and simply reach them far more often now.
//
// `el.state.root` is the ROOT STATE the colour map lives on. The chain
// mirrors the one pages/main.js already uses at its own root-from-element
// sites (`el.state?.root || el.getRoot?.()?.state?.root || …`) so a leaf
// mounted before its state binds resolves neutral rather than throwing —
// one throw inside a colour factory kills that element's whole effect.
export function posterCardHue(el) {
  const card = el.lookup((c) => !!c.posterId)
  if (!card) return null
  const root = el.state?.root || el.getRoot?.()?.state?.root || el.getRoot?.()?.state || null
  return el.call('homeWidgetSurfaceHue', root, card.posterId)
}
